import { createAction } from '@reduxjs/toolkit';

export const REMOVE_SUCCESS_ORDER = 'REMOVE_SUCCESS_ORDER';

export const removeSuccessOrder = createAction(
    REMOVE_SUCCESS_ORDER,
    () => ({ payload: [] }),
);
